import React, { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import moonscapeQrCode from "@/assets/images/moonscape-qr-code.svg";

interface QRCodePromotionProps {
  variant?: "banner" | "card";
  onClose?: () => void;
}

export const QRCodePromotion: React.FC<QRCodePromotionProps> = ({
  variant = "banner",
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    onClose?.();
    localStorage.setItem("hideQRPromotion", "true");
  };

  React.useEffect(() => {
    const hidePromotion = localStorage.getItem("hideQRPromotion");
    if (hidePromotion === "true") {
      setIsVisible(false);
    }
  }, []);

  if (!isVisible) return null;

  if (variant === "banner") {
    return (
      <div className="bg-gradient-to-r from-[#2A2C2B] to-[#333534] border border-gray-700 rounded-xl p-4 md:p-5 shadow-lg relative overflow-hidden">
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-200 transition-colors z-10"
          aria-label="Close promotion"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>

        <div className="flex items-center gap-4 md:gap-6">
          <div className="flex-shrink-0 bg-[#1C1F1D] rounded-lg p-2 shadow-md border border-gray-700">
            <img
              src={moonscapeQrCode}
              alt="Moonscape QR Code"
              className="w-20 h-20 md:w-24 md:h-24"
            />
          </div>

          <div className="flex-grow">
            <h3 className="text-white text-lg md:text-xl font-semibold mb-1">
              Moonscape is even better in the app
            </h3>
            <p className="text-gray-400 text-sm md:text-base">
              Scan the QR code to download now
            </p>
            <div className="flex items-center gap-2 mt-2">
              <a 
                href="https://apps.apple.com/us/app/moonscape-crypto-tax-tracker/id6686407896"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-green-500/20 text-green-400 border border-green-500/30 hover:bg-green-500/30 transition-colors"
              >
                iOS App Store →
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#2A2C2B] rounded-xl border border-gray-700 p-5 shadow-sm relative">
      <button
        onClick={handleClose}
        className="absolute top-3 right-3 text-gray-500 hover:text-gray-300 transition-colors"
        aria-label="Close promotion"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>

      <div className="flex flex-col items-center text-center">
        <div className="bg-[#1C1F1D] border border-gray-700 rounded-xl p-3 mb-4">
          <img
            src={moonscapeQrCode}
            alt="Moonscape QR Code"
            className="w-32 h-32"
          />
        </div>
        
        <h3 className="text-lg font-semibold text-white mb-2">
          Try Moonscape on Mobile
        </h3>
        <p className="text-sm text-gray-400 mb-1">
          Track your crypto portfolio on the go
        </p>
        <p className="text-xs text-gray-500">
          Scan with your phone camera to download
        </p>
        <a 
          href="https://apps.apple.com/us/app/moonscape-crypto-tax-tracker/id6686407896"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-green-500/20 text-green-400 border border-green-500/30 hover:bg-green-500/30 transition-colors mt-3"
        >
          iOS App Store →
        </a>
      </div>
    </div>
  );
};